import React, { FC, useState, useEffect } from 'react';
import { Box, Button, Stack, FormControlLabel, Checkbox } from '@mui/material';
import Terms from '../common/Terms';
import { useRegistrationContext } from '../../contexts/RegistrationContext';
import termsService from '../../services/TermsServices';
import { Term } from '../../redux/types/terms';

interface TermsAcceptanceFormProps {
  onBack: () => void;
  onSubmit: () => void;
}

export const TermsAcceptanceForm: FC<TermsAcceptanceFormProps> = ({
  onBack,
  onSubmit,
}) => {
  const { formData } = useRegistrationContext();
  const [terms, setTerms] = useState<Term | null>(null);
  const [accept, setAccept] = useState(false);

  useEffect(() => {
    termsService.getTerms().then(response => setTerms(response));
  }, []);

  const isFormValid = () => {
    return (
      formData.RUT !== '' &&
      formData.RUTError === '' &&
      formData.name !== '' &&
      formData.lastName !== '' &&
      formData.password !== '' &&
      formData.confirmation === formData.password &&
      formData.birthday !== null &&
      formData.passwordError === '' &&
      formData.sex !== '' &&
      formData.height !== '' &&
      formData.weight !== '' &&
      accept === true
    );
  };

  return (
    <Box sx={{ paddingX: '5%' }}>
      <Button
        onClick={onBack}
        size="small"
        sx={{ marginY: '2%', fontWeight: 'bold' }}
        variant="text"
      >
        {'← Atras'}
      </Button>
      <Terms content={terms?.content || ''} />

      <Box sx={{ marginX: '5vw' }}>
        <FormControlLabel
          sx={{ marginY: '16px' }}
          onChange={() => setAccept(!accept)}
          control={<Checkbox checked={accept} />}
          label="He leído y acepto los términos y condiciones de uso"
        />
      </Box>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={12}
      >
        <Button
          onClick={onSubmit}
          size="large"
          sx={{
            width: '100%',
            marginY: '2%',
            fontWeight: 'bold',
            borderRadius: '50px',
          }}
          disabled={!isFormValid()}
          variant="contained"
        >
          EMPEZAR
        </Button>
      </Stack>
    </Box>
  );
};
